// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"bc2bb7c3","366":"8d3d3b95","503":"56088489","846":"e82dbee4"}[chunkId] + ".chunk.js";
};